import { container } from "assets/jss/material-kit-pro-react.jsx";

const tabsStyle = {
  section: {
    padding: "70px 0"
  },
  container,
  textCenter: {
    textAlign: "center"
  }
};

export default tabsStyle;
